module.exports = __webpack_public_path__ + "img/Slice10-min.2c04d5a4.png";